var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotatePhone(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 284.68 330.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#043e4b;}.cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.47,189.66a3.72,3.72,0,1,0-7.43,0v3.71a3.72,3.72,0,1,0,7.43,0v-3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.47,163.62v-3.71a3.72,3.72,0,1,0-7.43,0v3.71a3.72,3.72,0,1,0,7.43,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.47,133.87v-3.71a3.72,3.72,0,1,0-7.43,0v3.71a3.72,3.72,0,1,0,7.43,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.47,119v-3.72a3.72,3.72,0,1,0-7.43,0V119a3.72,3.72,0,1,0,7.43,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.47,204.53a3.72,3.72,0,1,0-7.43,0v3.72a3.72,3.72,0,1,0,7.43,0v-3.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.47,174.78a3.72,3.72,0,1,0-7.43,0v3.72a3.72,3.72,0,1,0,7.43,0v-3.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.47,148.75V145a3.72,3.72,0,1,0-7.43,0v3.72a3.72,3.72,0,1,0,7.43,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M175.85,219.41a3.71,3.71,0,0,0-3.72-3.72h-3.69a3.72,3.72,0,1,0,0,7.43h3.69a3.71,3.71,0,0,0,3.72-3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M144.69,0H51.38c-7,0-13,4.5-15.76,10.76l-.06.41a16.08,16.08,0,0,0-.93,5.21V206.74A16.4,16.4,0,0,0,51,223.12h93.68a16.4,16.4,0,0,0,16.38-16.38V16.38A16.4,16.4,0,0,0,144.69,0ZM109,11.16h3.72a3.72,3.72,0,0,1,0,7.43H109a3.72,3.72,0,1,1,0-7.43Zm-26,0H97.85a3.72,3.72,0,1,1,0,7.43H83a3.72,3.72,0,1,1,0-7.43ZM97.85,212a14.88,14.88,0,1,1,14.88-14.88A14.89,14.89,0,0,1,97.85,212Zm55.78-40.91H42.07V29.75H153.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.35,129.34V133a3.72,3.72,0,0,0,7.44,0v-3.69a3.72,3.72,0,0,0-7.44,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M240.8,215a3.72,3.72,0,1,0,2.83,6.88,16.14,16.14,0,0,0,4.09-2.43,3.72,3.72,0,1,0-4.69-5.78A8.67,8.67,0,0,1,240.8,215"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.35,158.9v3.69a3.72,3.72,0,0,0,7.44,0V158.9a3.72,3.72,0,0,0-7.44,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.35,188.46v3.69a3.72,3.72,0,0,0,7.44,0v-3.69a3.72,3.72,0,0,0-7.44,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.35,144.12v3.69a3.72,3.72,0,0,0,7.44,0v-3.69a3.72,3.72,0,0,0-7.44,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.35,203.24v3.69a3.64,3.64,0,0,0,3.72,3.63,3.81,3.81,0,0,0,3.72-3.82v-3.5a3.72,3.72,0,0,0-7.44,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.35,173.68v3.69a3.72,3.72,0,0,0,7.44,0v-3.69a3.72,3.72,0,0,0-7.44,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.19,219.41a3.72,3.72,0,0,0-3.72-3.72h-3.7a3.72,3.72,0,0,0,0,7.43h3.7a3.72,3.72,0,0,0,3.72-3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M235,219.41a3.72,3.72,0,0,0-3.72-3.72h-3.7a3.72,3.72,0,1,0,0,7.43h3.7a3.72,3.72,0,0,0,3.72-3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M190.63,219.41a3.72,3.72,0,0,0-3.72-3.72h-3.7a3.72,3.72,0,0,0,0,7.43h3.7a3.72,3.72,0,0,0,3.72-3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.41,219.41a3.71,3.71,0,0,0-3.72-3.72H198a3.72,3.72,0,1,0,0,7.43h3.69a3.71,3.71,0,0,0,3.72-3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M162.68,104.12a3.71,3.71,0,0,0,3.72,3.72h3.69a3.72,3.72,0,1,0,0-7.43H166.4a3.71,3.71,0,0,0-3.72,3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207,104.12a3.71,3.71,0,0,0,3.72,3.72h3.69a3.72,3.72,0,1,0,0-7.43h-3.69a3.71,3.71,0,0,0-3.72,3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.8,104.12a3.71,3.71,0,0,0,3.72,3.72h3.69a3.72,3.72,0,1,0,0-7.43h-3.69a3.71,3.71,0,0,0-3.72,3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.65,103.61l-.1.84a3.72,3.72,0,0,0,2.88,3.62,9,9,0,0,1,2.41,1,3.72,3.72,0,0,0,3.71-6.45,16.16,16.16,0,0,0-4.44-1.74,3.72,3.72,0,0,0-4.46,2.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M246.15,114.57l.06.65a9.08,9.08,0,0,1,.14,1.57v1.47a3.72,3.72,0,0,0,7.44,0v-1.47a16.9,16.9,0,0,0-.25-2.86,3.72,3.72,0,0,0-7.39.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.46,104.12a3.71,3.71,0,0,0,3.71,3.72h3.7a3.72,3.72,0,1,0,0-7.43h-3.7a3.71,3.71,0,0,0-3.71,3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.24,104.12a3.71,3.71,0,0,0,3.72,3.72h3.69a3.72,3.72,0,1,0,0-7.43H196a3.71,3.71,0,0,0-3.72,3.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M172,14.87a3.72,3.72,0,0,0,3.72,3.72A41,41,0,0,1,216.6,59.5v9.62l-16-16a3.72,3.72,0,0,0-5.25,5.26l22.3,22.31a3.72,3.72,0,0,0,1.22.81,3.77,3.77,0,0,0,2.84,0,3.68,3.68,0,0,0,1.21-.81l22.31-22.31A3.72,3.72,0,0,0,240,53.15l-16,16V59.5a48.4,48.4,0,0,0-48.35-48.34A3.72,3.72,0,0,0,172,14.87"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 75.2,
    y: 180.5,
    width: 43.99,
    height: 32.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,330.3V290.61H10.29a22.76,22.76,0,0,1,6.88.91,8,8,0,0,1,4.41,3.21,11.3,11.3,0,0,1,1.55,6.37,20,20,0,0,1-.42,4.33,8.51,8.51,0,0,1-1.47,3.29,7.17,7.17,0,0,1-3,2.22l5.48,19.36H15.48l-4.55-18H8.08v18Zm8.08-22.78h2.36a6.33,6.33,0,0,0,3.08-.64,3.52,3.52,0,0,0,1.6-1.94,9.56,9.56,0,0,0,.46-3.21,7.33,7.33,0,0,0-1-4.19q-1-1.44-3.75-1.44H8.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.35,330.84a13.07,13.07,0,0,1-6.91-1.57,8.68,8.68,0,0,1-3.65-4.48,19.68,19.68,0,0,1-1.11-7V303a19.47,19.47,0,0,1,1.11-7,8.44,8.44,0,0,1,3.65-4.41,13.49,13.49,0,0,1,6.91-1.52,13.53,13.53,0,0,1,7,1.54A8.58,8.58,0,0,1,50,296.07,19.27,19.27,0,0,1,51.11,303V317.8a19.68,19.68,0,0,1-1.11,7,8.66,8.66,0,0,1-3.67,4.48A13.32,13.32,0,0,1,39.35,330.84Zm0-5.83a3.23,3.23,0,0,0,2.3-.71,3.57,3.57,0,0,0,1-1.91,13.15,13.15,0,0,0,.24-2.58V301.05a12.7,12.7,0,0,0-.24-2.55,3.54,3.54,0,0,0-1-1.89,3.23,3.23,0,0,0-2.3-.71,3.09,3.09,0,0,0-2.21.71,3.54,3.54,0,0,0-1,1.89,12.7,12.7,0,0,0-.24,2.55v18.76a14,14,0,0,0,.22,2.58,3.41,3.41,0,0,0,1,1.91A3.16,3.16,0,0,0,39.35,325Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.93,330.3V296.64H53.8v-6H74.09v6h-6V330.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.28,330.3,82,290.61h9l7.65,39.69h-7.5l-1.42-8.72H83.4l-1.52,8.72Zm9.85-13.67h4.75l-2.4-16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M104.32,330.3V296.64H98.19v-6h20.29v6h-6V330.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M122.06,330.3V290.61h17.29v5.59h-9.21v10.53h7.11v5.64h-7.11v12.44h9.31v5.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M155.77,330.3V290.61h12.59a11.23,11.23,0,0,1,5.83,1.35,8.22,8.22,0,0,1,3.36,3.89,15.63,15.63,0,0,1,1.1,6.18,13,13,0,0,1-1.44,6.66,8,8,0,0,1-4,3.41,15.3,15.3,0,0,1-5.73,1h-3.68v17.2Zm8.08-22.88h2.84a5.32,5.32,0,0,0,2.72-.57,2.85,2.85,0,0,0,1.3-1.78,11.88,11.88,0,0,0,.35-3.14,15.14,15.14,0,0,0-.27-3,3.08,3.08,0,0,0-1.21-1.91,5,5,0,0,0-2.93-.69h-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M182.62,330.3V290.61h8.08v16.32h7V290.61h8.08V330.3h-8.08V312.71h-7V330.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223,330.84a13.1,13.1,0,0,1-6.91-1.57,8.77,8.77,0,0,1-3.65-4.48,19.92,19.92,0,0,1-1.1-7V303a19.7,19.7,0,0,1,1.1-7,8.53,8.53,0,0,1,3.65-4.41,16.55,16.55,0,0,1,13.9,0,8.58,8.58,0,0,1,3.67,4.41,19.29,19.29,0,0,1,1.1,6.94V317.8a19.69,19.69,0,0,1-1.1,7,8.66,8.66,0,0,1-3.67,4.48A13.36,13.36,0,0,1,223,330.84Zm0-5.83a3.24,3.24,0,0,0,2.31-.71,3.64,3.64,0,0,0,1-1.91,13.15,13.15,0,0,0,.24-2.58V301.05a12.7,12.7,0,0,0-.24-2.55,3.61,3.61,0,0,0-1-1.89,3.24,3.24,0,0,0-2.31-.71,3.06,3.06,0,0,0-2.2.71,3.54,3.54,0,0,0-1,1.89,12,12,0,0,0-.25,2.55v18.76a14.94,14.94,0,0,0,.22,2.58,3.48,3.48,0,0,0,1,1.91A3.15,3.15,0,0,0,223,325Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M240.14,330.3V290.61h5.64l8.82,20.68V290.61h6.66V330.3h-5.39l-8.82-21.95V330.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M267.29,330.3V290.61h17.3v5.59h-9.22v10.53h7.11v5.64h-7.11v12.44h9.31v5.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotatePhone);
export default __webpack_public_path__ + "static/media/rotatePhone.7cdef4dac9cee7233b419975709b091d.svg";
export { ForwardRef as ReactComponent };